import * as React from 'react';

export function SvgAdmin() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 24 24">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
          fill="#DDDEE1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3897 4.82007H13.5803L14.5841 7.49698L17.4046 7.02783L19 9.79101L17.1833 11.9992L18.9996 14.207L17.4043 16.9702L14.5841 16.5011L13.5803 19.178H10.3897L9.38575 16.5009L6.56566 16.97L4.97033 14.2068L6.78646 11.9992L4.96997 9.79126L6.56529 7.02808L9.38573 7.49723L10.3897 4.82007ZM11.9852 14.6911C13.472 14.6911 14.6773 13.4858 14.6773 11.999C14.6773 10.5122 13.472 9.30691 11.9852 9.30691C10.4984 9.30691 9.29307 10.5122 9.29307 11.999C9.29307 13.4858 10.4984 14.6911 11.9852 14.6911Z"
          fill="#101214"
        />
      </svg>
    </span>
  );
}
